// extracted by mini-css-extract-plugin
export default {"value":"CalculationSection_value__-poXl","wrapper":"CalculationSection_wrapper__ZQ1yt"};